import { reportingDataService } from './services';
import { FancyCard } from './components';
import { faBook } from '@fortawesome/free-solid-svg-icons';
import { ModuleTypeEnum } from '../../enums';
import { IModuleConfig } from '../../interfaces';
import { BackButton } from '../reports/components/toolbar-items';
import { ItemPage } from '../reports/components';
import { UserPermissions } from '../../definitions';

const config: IModuleConfig = {
  id: 'reports',
  name: 'Reports',
  view_permission: UserPermissions.viewReports,
  edit_permission: UserPermissions.exportReports,
  icon: faBook,
  moduleType: ModuleTypeEnum.DualPaneLibrary,
  allowSearch: true,
  components: {
    libraryCard: FancyCard,
    itemPage: ItemPage
  },
  services: {
    getByPage: reportingDataService.getByPage,
    getSingle: reportingDataService.getSingle
  },
  utilities: {
    extractKey: (d: any) => d.name,
    extractItemPath: (d: any) => d._id,
    extractItemBreadcrumb: (d: any) => `${d._id}`
  },
  toolbarItems: {
    library: [],
    create: [BackButton],
    edit: [],
    view: [BackButton]
  }
};

export default config;
